import React from "react"

import GetStarted from "./GetStarted"
import Acceptance from "./Acceptance"

const Info = () => (
  <aside className="info">
    <GetStarted />
    <Acceptance />
  </aside>
)

export default Info
